import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KomunikatyTabeli, KomunikatyTabeliService } from '../../../@core/utils/komunikaty-tabeli.service';

import { SumowanieKwotService } from '../../../@core/utils/sumowanie-kwot.service';
import { PrzychodyKoszty } from '../../../shared/models/przychody-koszty.model';
import { ZakresDat } from '../../../shared/models/zakres-dat.model';
import { KwotaPipe } from '../../../shared/pipes';

@Component({
  selector: 'ngx-przychody-koszty-tabela',
  templateUrl: './przychody-koszty-tabela.component.html',
  styleUrls: ['./przychody-koszty-tabela.component.scss'],
})
export class PrzychodyKosztyTabelaComponent implements OnInit {

  _dane: PrzychodyKoszty[];
  _danePdf: PrzychodyKoszty[];
  _daneXls: PrzychodyKoszty[];
  currentSort: { prop: string; dir: string } = null;

  @Input()
  zakresDat: ZakresDat;

  temp = [];
  eksportKolumny = [];
  eksportXlsKolumny = [];
  eksportPdfKolumnyStyle;
  wyswietlanieFiltrow = false;

  @Input()
  wyswietlanieKosztow: boolean;

  @Input() set dane(value: PrzychodyKoszty[]) {
    if (value) {
      this.temp = [...value];
      this._danePdf = this.uzupelnijDanePdf([...value]);
      this._daneXls = this.uzupelnijDaneXls([...value]);
      this._dane = value;
    }
  }

  get dane(): PrzychodyKoszty[] {
    return this._dane;
  }

  get danePdf(): PrzychodyKoszty[] {
    return this._danePdf;
  }

  get daneXls(): PrzychodyKoszty[] {
    return this._daneXls;
  }

  komunikatyTabeli: KomunikatyTabeli;

  constructor(
    private readonly komunikatyTabeliService: KomunikatyTabeliService,
    private readonly translate: TranslateService,
  ) { }

  ngOnInit() {
    this.odswiezKomunikatyTabeli();
    this.translate.onLangChange.subscribe(() => this.odswiezKomunikatyTabeli());

    this.odswiezKolumnyPdf();
    this.translate.onLangChange.subscribe(() => this.odswiezKolumnyPdf());
  }

  updateFilter(event, prop) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function (d) {
      return (d[prop] != null && d[prop].toString().toLowerCase().indexOf(val) !== -1) || !val;
    });
    this._dane = temp;
  }

  updateFilterMobile(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function (d) {
      return (d.okres != null && d.okres.toString().toLowerCase().indexOf(val) !== -1) || 
             (d.przychody != null && d.przychody.toString().toLowerCase().indexOf(val) !== -1) ||
             (d.koszty != null && d.koszty.toString().toLowerCase().indexOf(val) !== -1) ||
             (d.saldo != null && d.saldo.toString().toLowerCase().indexOf(val) !== -1) ||
             !val;
    });
    this._dane = temp;
  }

  sumaKwota(value: number[]) {
    return new SumowanieKwotService().suma(value);
  }

  sumaPrzychodow(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.przychody || 0), 0);
  }

  sumaKosztow(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.koszty || 0), 0);
  }

  sumaSaldo(): number {
    if (!this.dane) return 0;
    return this.dane.reduce((sum, item) => sum + (item.saldo || 0), 0);
  }

  private odswiezKomunikatyTabeli() {
    this.komunikatyTabeli = this.komunikatyTabeliService.get();
  }

  private odswiezKolumnyPdf() {
    this.eksportKolumny = [
      {header: this.translate.instant('etykieta.lp'), dataKey: 'liczbaPorzadkowa', styles: { halign: 'center' }},
      {header: this.translate.instant('etykieta.okres'), dataKey: 'okres', styles: { halign: 'center' }},
      {header: this.translate.instant('etykieta.przychody'), dataKey: 'przychodyPdf', styles: { halign: 'center' }},
      {header: this.translate.instant('etykieta.koszty'), dataKey: 'kosztyPdf', styles: { halign: 'center' }},
      {header: this.translate.instant('etykieta.saldo'), dataKey: 'saldoPdf', styles: { halign: 'center' }}
    ];

    this.eksportXlsKolumny = [
      {header: this.translate.instant('etykieta.lp'), dataKey: 'liczbaPorzadkowa'},
      {header: this.translate.instant('etykieta.okres'), dataKey: 'okres'},
      {header: this.translate.instant('etykieta.przychody'), dataKey: 'przychody'},
      {header: this.translate.instant('etykieta.koszty'), dataKey: 'koszty'},
      {header: this.translate.instant('etykieta.saldo'), dataKey: 'saldo'}
    ];

    // Column styles for data rows
    this.eksportPdfKolumnyStyle = {
      liczbaPorzadkowa: { halign: 'right' },
      okres: { halign: 'center' },
      przychodyPdf: { halign: 'right' },
      kosztyPdf: { halign: 'right' },
      saldoPdf: { halign: 'right' }
    };
  }

  uzupelnijDanePdf(value: any[]) {
    const kwotaPipe = new KwotaPipe();
    let sumaPrzychody = 0;
    let sumaKoszty = 0;
    let sumaSaldo = 0;
    value.forEach(e => {
      sumaPrzychody += e.przychody;
      sumaKoszty += e.koszty;
      sumaSaldo += e.saldo;
      e.przychodyPdf = kwotaPipe.transform(e.przychody);
      e.kosztyPdf = kwotaPipe.transform(e.koszty);
      e.saldoPdf = kwotaPipe.transform(e.saldo);
    });
    value.push({
      'przychodyPdf': kwotaPipe.transform(sumaPrzychody),
      'kosztyPdf':  kwotaPipe.transform(sumaKoszty),
      'saldoPdf': kwotaPipe.transform(sumaSaldo),
    });
    return value;
  }

  uzupelnijDaneXls(value: any[]) {
    let sumaPrzychody = 0;
    let sumaKoszty = 0;
    let sumaSaldo = 0;

    const cleanData = value.map(e => {
      sumaPrzychody += e.przychody;
      sumaKoszty += e.koszty;
      sumaSaldo += e.saldo;
      return {
        liczbaPorzadkowa: e.liczbaPorzadkowa,
        okres: e.okres,
        przychody: e.przychody,
        koszty: e.koszty,
        saldo: e.saldo
      };
    });

    cleanData.push({
      liczbaPorzadkowa: '',
      okres: 'SUMA',
      przychody: sumaPrzychody,
      koszty: sumaKoszty,
      saldo: sumaSaldo
    });

    return cleanData;
  }

  onSort(event: any) {
    this.currentSort = event.sorts[0];
    // Update PDF data with current sort
    if (this.currentSort) {
      const sortedData = [...this._danePdf];
      const lastRow = sortedData.pop(); // Remove summary row
      sortedData.sort((a, b) => {
        const dir = this.currentSort.dir === 'desc' ? -1 : 1;
        const aVal = a[this.currentSort.prop];
        const bVal = b[this.currentSort.prop];

        if (typeof aVal === 'number') {
          return (aVal - bVal) * dir;
        } else {
          return aVal.localeCompare(bVal) * dir;
        }
      });
      this._danePdf = [...sortedData, lastRow]; // Add summary row back
    }
  }
}
